<template>
  <v-col
    v-if="enabled"
    :cols="cols"
    :lg="lg"
    :md="md"
  >
    <v-row dense>
      <v-col
        v-if="label"
        :class="labelClass"
        cols="12"
      >
        <span>{{ $bct(label) }}</span>
        <RequiredIndicator v-if="mandatory" />
      </v-col>
      <template v-if="description">
        <v-col
          class="fs-16 c-light-black my-1"
          cols="12"
        >
          <span>{{ $bct(description) }}</span>
        </v-col>
      </template>
      <v-col>
        <v-textarea
          @blur="handleBlur"
          @update:model-value="handleUpdateModelValue"
          :append-inner-icon="locked ? 'lock' : ''"
          :aria-label="$bct(ariaLabel)"
          :density="dense ? 'compact' : undefined"
          :disabled="locked"
          :model-value="localValue"
          data-cy="labeled-text-area"
          variant="filled"
          hide-details
          tile
          v-bind="filteredAttrs"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import { onUpdated } from 'vue';
import useLabeledField from '@/shared/composables/useLabeledField';
import useSchematizedField from '@/shared/composables/useSchematizedField';
import attrsOmitDataPrefix from '@/shared/utils/filteredAttrs';
import propsToRefs from '@/shared/utils/propsToRefs';
import RequiredIndicator from '@/shared/components/RequiredIndicator.vue';

const $bct = inject('translator');

const props = defineProps({
  ...useLabeledField.props,
  ...useSchematizedField.props,
});

defineEmits(useLabeledField.emits);

const localValue = defineModel({ type: String });

const attrs = useAttrs();
const filteredAttrs = ref(attrsOmitDataPrefix(attrs));

const { enabled, label, ariaLabel, locked, labelClass } = useSchematizedField(
  ...propsToRefs(props, useSchematizedField.paramKeys),
);

const { handleBlur, handleUpdateModelValue } = useLabeledField(
  ...propsToRefs(props, useLabeledField.paramKeys),
);

// attrs is not a reactive object, so we update the filteredAttrs ref on every DOM tree update
onUpdated(() => {
  filteredAttrs.value = attrsOmitDataPrefix(attrs);
});
</script>
